import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config';
import { User,  } from '../models';

@Injectable()
export class UserService {

  constructor(
    private config: Config,
    private http: HttpClient
  ) { }

  changePassword(oldPassword: string, newPassword: string): Observable<HttpResponse<void>> {
    const params = {
      oldPassword, newPassword
    };

    return this.http.post<HttpResponse<any>>(this.config.get('API_SERVER_URL') + '/auth/passwd', params);
  }

  getProfile(): Observable<User> {
    /*
    return new Observable(observer => {
      let user = new User();
      user.active = true;
      user.checked = false;
      user.companyName = 'Dgpark';
      user.email = 'adam.zalewski@dgpark.pl';
      user.id = 1;
      user.login = 'adam';
      user.name = 'Adam Zalewski';
      user.system = false;
      user.telephone = '693390812';
      observer.next(user);
    });
    */
    return this.http.get<User>(this.config.get('API_SERVER_URL') + '/auth/profile');
  }

}
